export default {
  Url: "mon-compte",
  Global: {
    Email: "E-mail",
    Password: "Mot de passe",
    Firstname: "Prénom",
    Lastname: "Nom",
    Phone: "Téléphone",
    Language: "Langue",
    PasswordConfirm: "Confirmer le mot de passe",
  },
  Contact: {
    Validation: {
      MissingField: "Merci de renseigner tous les champs.",
      InvalidEmail: "Merci de saisir un e-mail valide pour que nous puissions vous répondre.",
      MessageSent: "Votre message a été envoyé.",
      Error: "Erreur",
    },
  },
  Pricing: {
    Team: "Team",
    TeamSubtitle: "Toutes les fonctionnalités indispensables pour démarrer",
    Business: "Business",
    BusinessSubtitle: "Pour un usage expert de la gestion de projet et l'organisation des équipes",
    Enterprise: "Enterprise",
    EnterpriseSubtitle: "Un accompagnement dédié dans votre déploiement multi-équipes",
    Annual: "Annuel",
    Monthly: "Mensuel",
    Offer: "2 mois offerts",
    User: "utilisateur",
    Users: "utilisateurs",
  },
  MyAccount: {
    Title: "Mon compte",
    Menu: {
      Profile: "Profil",
      Company: "Entreprise",
      Billing: "Facturation",
      Premium: "Premium",
      LogOut: "Déconnexion",
    },
    Profile: {
      Title: "Mon Profil",
      ChangeEmail: "Changer l'e-mail",
      NewEmail: "Nouvel e-mail",
      ChangePassword: "Changer le mot de passe",
      OldPassword: "Ancien mot de passe",
      NewPassword: "Nouveau mot de passe",
      Change: "Changer",
      DeleteAccount: "Supprimer mon compte et mes données personnelles",
      DeleteAccountDescription: "Cette action supprimera votre compte Utilisateur et vos projets. Elle n'est pas réversible.\nSi vous souhaitez arrêter un abonnement Premium, vous devez le faire dans la section Premium au préalable.",
      DeleteAccountConfirmation: "Confirmer la suppression définitive du compte ?",
      DeleteAccountConfirmationMessage: "Votre compte a bien été supprimé.",
    },
    Login: {
      Title: "Connexion",
      NotLoguedIn: "Vous devez d'abord vous identifier",
      GoToLogin: "Aller à la page d'identification.",
      LogIn: "Me connecter",
      NotHaveAccount: "Je n'ai pas encore de compte",
    },
    Company: {
      Title: "Mon Entreprise",
      Details: "Détails de l'entreprise",
      Name: "Nom de l'entreprise",
      Logo: "Logo",
      ChangeLogo: "Changer",
      PostalAddress: "Adresse de facturation",
      Email: "E-mail administratif",
      Domiciliation: "Domiciliation",
      VatNumber: "Numéro de TVA intracommunautaire",
      Country: "Pays",
      France: "France",
      EuropeanUnion: "Union Européenne",
      NonEu: "Hors UE",
      CompanyNameError: "Le champ doit comporter entre 3 et 50 caractères",
      VatNumberError: "Le numéro de TVA intracommunautaire est invalide",
      Leave: "Quitter cette entreprise",
      UsersInCompany: "Utilisateurs de l'entreprise",
      UsersWantToJoin: "Ces utilisateurs souhaitent rejoindre votre entreprise",
      Accept: "Accepter",
      Reject: "Refuser",
      Or: "ou",
      InviteToJoin: "Inviter des utilisateurs dans l'entreprise",
      SendInvite: "Envoyer l'invitation",
    },
    NoCompany: {
      Title: "Rejoindre une Entreprise",
      NoAttachedCompany: "Votre compte n'est rattaché à aucune entreprise",
      CompanyName: "Nom de l'entreprise",
      RequestToJoin: "Rejoindre une entreprise existante",
      SendRequest: "Envoyer la demande",
      OrCreateNew: "Passer Premium et créer un compte entreprise",
      JoinInvites: "Vous avez été invité à rejoindre une entreprise existante",
      Join: "Rejoindre",
    },
    Premium: {
      Title: "Abonnement Premium",
    },
    Checkout: {
      Title: "Valider votre commande",
      TitleNewCard: "Changer de carte",
    },
    LogOut: {
      Title: "",
      LoggingOut: "Déconnexion en cours...",
    },
  },
};
